import { productBelongsToCategory } from './productCategories';

export default {
  setStoreList(state, list) {
    state.store.storeList = [...state.store.storeList, ...list];
  },

  fetchStoreList(state, list = []) {
    state.store.storeList = list;
  },

  setStorePageInfo(state, pageInfo) {
    state.store.pageInfo = pageInfo;
  },

  setStorePage(state, page = 1) {
    state.store.pageInfo.page = page;
  },

  setStoreTotalPage(state, totalPage = 2) {
    state.store.pageInfo.totalPage = totalPage;
  },

  setRecommendedStoreList(state, list) {
    state.recommended.recommendedStoreList = list;
  },

  fetchRecommendedStoreList(state, list) {
    state.recommendedStoreList = list;
  },

  setRecommendedPageInfo(state, pageInfo) {
    state.recommended.pageInfo = pageInfo;
  },

  setRecommendedStorePage(state, page = 1) {
    state.recommended.pageInfo.page = page;
  },

  setRecommendedTotalPage(state, totalPage = 2) {
    state.recommended.pageInfo.totalPage = totalPage;
  },
  purgeStoreList(state) {
    state.store.pageInfo = { page: 1, totalPage: 2 };
    state.store.storeList = [];
  },
  purgeRecommendedStoreList(state, list) {
    state.recommended.pageInfo = { page: 1, totalPage: 2 };
    state.recommended.recommendedStoreList = [];
  },
  setStoreOnline(state, isOnline) {
    state.storeInfo.isOnline = isOnline;
  },
  setStoreInfo(state, data) {
    data.isOnline = false;
    state.storeInfo = data;
  },
  initStoreInfo(state) {
    state.storeInfo = {};
  },
  setStoreFav(state, fav) {
    state.storeInfo.isFav = fav;
  },
  setPage(state, page = 1) {
    state.store.pageInfo.page = page;
  },

  setTotalPage(state, totalPage = 2) {
    state.store.pageInfo.totalPage = totalPage;
  },

  initStoreList(state) {
    state.store.pageInfo.page = 1;
    state.store.pageInfo.totalPage = 2;
    state.store.storeList = [];
  },

  initRecommendedStoreList(state) {
    state.recommended.pageInfo.page = 1;
    state.recommended.pageInfo.totalPage = 2;
    state.recommended.recommendedStoreList = [];
  },
  setRecentProducts: (state, list = []) => {
    state.recentProducts = list;
  },
  setProducts: (state, products = []) => {
    state.products = products.map((elem) => {
      elem.isFold = true;
      elem.idx = 1;
      elem.fetched = false;
      return elem;
    });
  },
  setAllProducts: (state, products = []) => {
    state.allProducts = products.map((elem) => {
      elem.isFold = true;
      elem.idx = 1;
      elem.fetched = false;
      return elem;
    });
  },
  setProductsFold: (state, { productCategoryNo }) => {
    const prod = [...state.products];
    const idx = prod.findIndex((elem) => {
      if (elem.productCategoryNo === productCategoryNo) return elem;
    });

    if (idx > -1) prod[idx].isFold = !prod[idx].isFold;

    state.products = prod;
  },
  setCategoryProductPageInfo: (state, pageInfo = { page: 1, totalPage: 2 }) => {
    state.productsPageInfo = pageInfo;
  },
  setSearchCategoryProduct: (state, { list = [], page = 1 }) => {
    if (page <= 1) {
      state.categoryProducts = list;
    } else {
      state.categoryProducts = [...state.categoryProducts, ...list];
    }
  },
  setCategoryProduct: (state, { productCategoryNo, products = [], page = 1 }) => {
    // --- 전체보기 (productCategoryNo === 0) ---
    if (productCategoryNo === 0) {
      state.products = state.products.map((cat) => {
        // 페이지 1이면 초기화
        const baseProducts = page <= 1 ? [] : cat.products ?? [];

        // 현재 카테고리에 속한 상품만 필터링
        const categoryProducts = products.filter((product) =>
          productBelongsToCategory(product, cat.productCategoryNo)
        );

        // 병합 후 반환
        return {
          ...cat,
          products: [...baseProducts, ...categoryProducts]
        };
      });
      return;
    }

    // --- 특정 카테고리 (일반 케이스) ---
    state.products = state.products.map((cat) => {
      if (cat.productCategoryNo !== productCategoryNo) return cat;

      // page === 1 -> 덮어쓰기, page > 1 -> 누적
      const merged = page > 1 ? [...(cat.products ?? []), ...products] : products;

      return {
        ...cat,
        products: merged
      };
    });
  },
  updateInfiniteKey(state) {
    state.infiniteKey += 1;
  },
  increaseIdx: (state, idx) => {
    const arr = [...state.products];
    arr[idx].idx += 1;
    state.products = arr;
  },
  decreaseIdx: (state, idx) => {
    const arr = [...state.products];
    arr[idx].idx -= 1;
    state.products = arr;
  },
  setStoreCategoryNo(state, data) {
    console.log(data);
    state.storeCategoryNo = data;
  }
};
